var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data.length === 0)?_c('div'):_vm._e(),_c('div',[_c('LineChartComponent',{key:_vm.chartKey,attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }